// prompttemplate.js
import { toastWrapper } from '../../_helpers';
import { PromptTemplateBase } from './PromptTemplateBase';

const PromptTemplate = () => {
    return <PromptTemplateBase isAdmin={false} toastFunction={toastWrapper.error} />;
};

export default PromptTemplate;
